import React, { useEffect, useState } from 'react'
import WrapperPageSimple from '../WrapperPage/present/WrapperPageSimple'
import config from '../../config.json'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import Translation, { getTranslationString } from '../Translation/cont/Translation'
import RadioButtonWrapper from '../forms/fields/RadioButtonWrapper'
import FieldWrapper from '../forms/FieldWrapper'
import SignageFilterSelectContainer from '../../containers/PageSignageLite/SignageFilterSelectContainer'
import ButtonSubmit from '../general/ButtonSubmit'
import { MULTICINEMA } from '../../constants/cinemaTypes'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Button from '../general/Button'

const PageSignageLitePage = ({pageName, cinemas, cliCinemasIdList, currentFrontCinemaId, currentLang, routesData, attributes}) => {
    const [signageLink, generateSignageLink] = useState(null)
    const [isCopied, setCopied] = useState(false)

    useEffect(() => {
        const timeOutId = setTimeout(() => setCopied(false), 2500)
    
        return () => {
            if(timeOutId) {
                clearTimeout(timeOutId)
            }
        }
    })
    const {program_overview} = routesData
    const programOverviewUri = program_overview[currentLang] ? program_overview[currentLang].uri : ""
    const timeFilter = ['no_timeframe', 'today', 'tomorrow', 'week']
    const frontCinemaIsMultiCinema = cinemas[currentFrontCinemaId] && cinemas[currentFrontCinemaId].scope.type === MULTICINEMA

    const initValues = {
        cinema: frontCinemaIsMultiCinema ? '' : currentFrontCinemaId,
        fsk: "",
        genres: "",
        technical: "",
        theatres: "",
        time: "",
        title: ""
    }

    return (
        <WrapperPageSimple pageTitleTransId={config.routes.signagelite.transId} pageTitle={pageName}>
            <div className="signage-lite-settings-page site-content">
            <Formik
                initialValues={initValues}
                onSubmit={(values, actions) => {
                    let signageQuerys = ""

                    _.keys(values).map(valueKey => {
                        const id = valueKey
                        const name = values[valueKey]
                        if(name !== '') {
                            let filterString = '&' + id + "=" + name 
                            if(id === 'theatres') {
                                filterString = "&theatreName=" + name
                            }
                            if(signageQuerys === "") {
                                signageQuerys = filterString
                            } else {
                                signageQuerys = signageQuerys.concat(filterString)
                            }
                        }
                    })

                    let generatedUrl = programOverviewUri + "signage/" + signageQuerys

                    generateSignageLink(generatedUrl)
                }}
            >
            {({values, errors, touched, isSubmitting, handleReset, setFieldValue}) => 
                <Form>
                    <div className={""}>
                        {_.has(values, "cinema") && cinemas && frontCinemaIsMultiCinema && cliCinemasIdList.length > 1 ? (
                            <fieldset className="field-cinemas">
                                <legend className="field-text-label choose-cinema"><Translation id="choose_cinema"/></legend>                                              
                                <div className="grid-container">
                                    <div key={'field_no-cinema'} className="field-checkbox">
                                        <RadioButtonWrapper id={'no-cinema'} label={<Translation id="choose_allcinemas"/>}>
                                            <Field
                                                id={'no-cinema'}
                                                type="radio"
                                                name="cinema"
                                                value={''}
                                            />
                                        </RadioButtonWrapper>
                                    </div>
                                    {cliCinemasIdList.map(cinemaId => {
                                        const cinema = cinemas[cinemaId]
                                        const {pk, nameDisplay} = cinema

                                        return (
                                            <div key={'field' + pk} className="field-checkbox">
                                                <RadioButtonWrapper id={pk} label={nameDisplay}>
                                                    <Field
                                                        id={pk}
                                                        type="radio"
                                                        name="cinema"
                                                        value={pk}
                                                    />
                                                </RadioButtonWrapper>
                                            </div>
                                        )
                                    })}
                                </div>
                                </fieldset>
                            ) : (
                                ''
                            )
                        }
                        <FieldWrapper label={<Translation id="content_title"/>} id="title" classes="field-text">
                            <Field type="text" name="title" id="title" className="text-regular input-text-box" />
                            <ErrorMessage name="title" component="div" /> 
                        </FieldWrapper>

                        <div className='field-text'>
                            <legend className="field-text-label set-timeframe"><Translation id="formik_datepicker_set_timeframe"/></legend>             
                            <div className='timeframe'>
                                {timeFilter.map((filterKey, index) => {
                                    const value = filterKey === "no_timeframe" ? '' : filterKey
                                    return <div className="field-checkbox" key={index}>
                                        <RadioButtonWrapper id={filterKey} label={<Translation id={"formik_datepicker_" + filterKey}/>}>
                                            <Field
                                                id={filterKey}
                                                type="radio"
                                                name="time"
                                                value={value}
                                            />
                                        </RadioButtonWrapper>
                                    </div>
                                })}
                            </div>
                        </div>
                        {values.cinema && attributes[values.cinema] ? (
                            <div className='field-text more-filter-wrapper'>
                                {_.keys(attributes[values.cinema]).map((filterKey, index) => {
                                    const filterItems = attributes[values.cinema][filterKey]
                                    return _.keys(filterItems).length !== 0 && <SignageFilterSelectContainer 
                                        filterItems={filterItems}
                                        values={values}
                                        name={filterKey}
                                        key={index}
                                    /> 
                                })}    
                            </div>
                        ) : (
                            <div className='field-text more-filter-wrapper'>
                            {_.keys(attributes.global).map((filterKey, index) => {
                                const filterItems = attributes.global[filterKey]
                                return _.keys(filterItems).length !== 0 && <SignageFilterSelectContainer 
                                    filterItems={filterItems}
                                    values={values}
                                    name={filterKey}
                                    key={index}
                                /> 
                            })}    
                        </div>
                        )}
                    </div>

                    {signageLink && <div className="field-text">
                        <div className="copy-wrapper">
                            <FieldWrapper label={<Translation id="signage_filter_generated_link"/>} id="signage-link" classes="field-text">
                                <input 
                                    id="signage-link"
                                    type="url" 
                                    readOnly={true}  
                                    value={signageLink}
                                    className='text-regular input-text-box'
                                />
                            </FieldWrapper>
                            <CopyToClipboard
                                text={signageLink} 
                                onCopy={() => setCopied(true)}
                            >
                                <Button
                                    className="copy-button button text-medium cursor-pointer"
                                    transId={"signage_copy_url"}
                                    type="button"
                                    hideText={false}
                                />
                            </CopyToClipboard>
                        </div>
                        {isCopied && <div className="copy-success text-small-medium ">
                            <Translation id="signage_copy_url_to_clipboard"/>
                        </div>}
                    </div>}

                    <ButtonSubmit
                        transIdSubmit={'signage_filter_create_link'}
                        onSubmit={() => {}}
                        disableTemporarily={false}
                        disablePermanently={false}
                    />
                </Form>
            }
        </Formik>
            </div>
        </WrapperPageSimple>
    )
}

export default PageSignageLitePage  